import axios from 'axios';


export function pad(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
}
export function numberWithCommas(x) {
    //alert(x);

    x = roundToTwo(x);


    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function stringToDateWithTime(stringDate) {
    let dateObject = stringToDayObject_local(stringDate);
    //console.log(dateObject);
    //alert("debug");


    let resText = dateObject.date + "/" + dateObject.month2digit + "/" + dateObject.year + " " + dateObject.hours2digit + ":" + dateObject.minutes2digit;

    return resText;
}



export function stringToDate(stringDate) {

    let myDate = new Date(stringDate);
    return myDate;


    // num = num.toString();
    // while (num.length < size) num = "0" + num;
    // return num;
}

export function stringToDayString(stringDate, languageCode) {

    let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    let d = new Date(stringDate);
    let dayName = days[d.getDay()];
    return dayName;
}

function roundToTwo(num) {
    return +(Math.round(num + "e+2") + "e-2");
}


function stringToDayObject_local(stringDate) {

    if (stringDate !== undefined) {
        let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ];



        let d = new Date(stringDate);
        let dayName = days[d.getDay()];
        let shortDayName = dayName.substr(0, 3);
        let month2digit = ("0" + (d.getMonth() + 1)).slice(-2);
        let monthName = months[d.getMonth()];
        let shortMonthName = monthName.substr(0, 3);
        let shortYear = d.getFullYear().toString().substr(-2);

        let result = {};
        result.dayName = dayName;
        result.shortDayName = shortDayName;
        result.monthName = monthName;
        result.shortMonthName = shortMonthName;
        result.month2digit = month2digit;
        result.hours = d.getHours();
        result.hours2digit = ("0" + result.hours).slice(-2);
        result.minutes = d.getMinutes();
        result.minutes2digit = ("0" + result.minutes).slice(-2);
        result.date = d.getDate();
        result.year = d.getFullYear();



        result.shortYear = shortYear;

        return result;
    }
    else {
        return "";
    }

}

export function stringToDayObject(stringDate) {

    return stringToDayObject_local(stringDate)
}



export function toDateFormat(value, format) {
    //d = 1-30
    //dd = 01-30
    //dddd = Friday
    //ddd = Fri

    //M = 1-12
    //MM = 01-12
    //MMM = Dec
    //MMMM = December

    //y = 21
    //yy = 021
    //yyy = 2015
    //yyyy = 2015

    let result = "";

    if (format === "d-MM-yyyy") {
        let dateObject = null;
        dateObject = stringToDayObject_local(value);
        //console.log(dateObject);

        result = dateObject.date + "/" + dateObject.month2digit + "/" + dateObject.year;

    }
    if (format === "d-MM-y") {
        let dateObject = null;
        dateObject = stringToDayObject_local(value);
        //console.log(dateObject);

        result = dateObject.date + "/" + dateObject.month2digit + "/" + dateObject.shortYear;

    }
    return result;
}
export function baseUrl() {
    // var base_url = window.location.origin;
    // var host = window.location.host;
    // var pathArray = window.location.pathname.split('/');
    return window.location.origin;
}
export function callPost(url, token, data, callBack) {
    axios
        .post(url, data, {
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            let data = response.data;
            if (data.Success === false && data.Message === "Authorization failed.") {
                window.localStorage.removeItem("userObject1");
                window.location.reload();
            }
            callBack(response.data);
        })
        .catch(err => {
            //alert("error");
            console.error(err)
        })
    //console.log("test3");
}

export function cleanString(input){
    input = input.trim();
    let inArr = input.split("");
    for(let i=0;i<inArr.length;i++){
        if(IsValidChar(inArr[i])== false){
            inArr[i] = "";
        }
    }
    let output = inArr.join("");
    return output;
}
function IsValidChar(c){
    let template = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@_-."
    let temArr = template.split("");
    let check = false;
    for(let i=0;i<temArr.length;i++){
        if(c===temArr[i]){
            check = true;
            break;
        }
    }
    return check;
}




// module.exports = {
//     callPost:callPost,
//     baseUrl:baseUrl,
//     toDateFormat:toDateFormat,
//     stringToDayObject:stringToDayObject,
//     stringToDayString:stringToDayString,
//     stringToDate:stringToDate,
//     pad:pad
// };











